module.exports = __webpack_public_path__ + "media/images/stripe-logo-956c6f1fe62b0bb519ef32b850424522.png";